import { useState } from "react";
import { Box, Toast, Icon } from "@/components";
import { truncateAddress } from "@/utils";

interface ReallocatePointsSuccessToastProps {
    newAddress: string;
    onClose?: () => void;
}

export function ReallocatePointsSuccessToast({ newAddress, onClose }: ReallocatePointsSuccessToastProps) {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        onClose?.();
    };

    return (
        <Toast
            open={open}
            onClose={handleClose}
            icon={<Icon name="CheckCircle" className="h-6 w-6 relative top-[2px]" />}
            severity="success"
            title="Points transferred"
        >
            <>
                <div className="h-px w-full bg-dialogBorder" />;
                <Box className="flex flex-col gap-2 px-4 pb-6">
                    <div className="flex flex-col space-y-2">
                        <div className="flex flex-col">
                            <div className="text-[#7F7887]">Transferred to</div>
                            <div className="text-white font-mono">{truncateAddress(newAddress)}</div>
                        </div>
                    </div>
                </Box>
            </>
        </Toast>
    );
}
